import { render, staticRenderFns } from "./chatArea.vue?vue&type=template&id=7bb8dcb2&scoped=true&"
import script from "./chatArea.vue?vue&type=script&lang=js&"
export * from "./chatArea.vue?vue&type=script&lang=js&"
import style0 from "./chatArea.vue?vue&type=style&index=0&id=7bb8dcb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8dcb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb8dcb2')) {
      api.createRecord('7bb8dcb2', component.options)
    } else {
      api.reload('7bb8dcb2', component.options)
    }
    module.hot.accept("./chatArea.vue?vue&type=template&id=7bb8dcb2&scoped=true&", function () {
      api.rerender('7bb8dcb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/chatArea.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/chatArea.vue
// module id = iyfS
// module chunks = 0